.dayRow {
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 350px;
}
